<form [formGroup]="form">
    <app-dropdown-autocomplete labelAlign="left"
                               [formControl]="form.controls.owner"
                               [showErrors]="showValidations"
                               [items]="owners"
                               [resetSelectionOnItemChange]="false"
                               [resetValueOnOpen]="true"
                               [label]="'admin.tools.batchUpdate.form.properties.owner.label' | translate"
                               [emptyText]="'admin.tools.batchUpdate.form.properties.owner.placeholder' | translate"
                               (selectItem)="onSelectedOwner($event)"
                               valueField="id">
    </app-dropdown-autocomplete>
    <div class="production-availability">
        <div class="production-availability-label"> {{ 'admin.tools.batchUpdate.form.properties.productionAvailability.label' | translate }}
        </div>
        <div class="production-availability-options">
            <app-input-checkbox
                [formControl]="form.controls.validForProduction"
                (select)="onProductionValidityChanged(true)">
                {{ 'admin.tools.batchUpdate.form.properties.productionAvailability.valid' | translate }}
            </app-input-checkbox>
            <app-input-checkbox
                [formControl]="form.controls.notValidForProduction"
                (select)="onProductionValidityChanged(false)">
                {{ 'admin.tools.batchUpdate.form.properties.productionAvailability.notValid' | translate }}
            </app-input-checkbox>
        </div>
    </div>
    <div *ngIf="isProductionValidityChanged" class="production-availability-reason">
        <app-textarea [formControl]="form.controls.validityReason"
                      [showErrors] = "showValidations"
                      [label]="'admin.tools.batchUpdate.form.properties.productionAvailability.reason.label' | translate"
                      [placeholder]="'admin.tools.batchUpdate.form.properties.productionAvailability.reason.placeholder' | translate">
        </app-textarea>
    </div>
</form>
